import React from 'react';
import { Grid, Skeleton, Box } from '@mui/material';

import PageContent from '@root/components/v2/layout/PageContent';
import PageHeaderSkeleton from '@root/components/v2/layout/PageHeader/Skeleton';
import {
  ActiveThreatSkeleton,
  AlertComponentsSkeleton,
  AssetOverviewSkeleton,
  AttackPathSkeleton,
  EntityFindingsSkeleton,
  LiveSecretsSkeleton,
  SensitiveDataSkeleton,
  TopActiveActorSkeleton,
} from './components/skeletons';
import './style.scss';

// Route-level fallback for /data-security: mirrors the grid in index-new.jsx card for card, reusing the same
// per-card skeletons the page shows as Suspense fallbacks, so nothing shifts once the page mounts.
function DataSecuritySkeleton() {
  return (
    <PageContent>
      <PageHeaderSkeleton isRegionFilter={true} />
      <div className="DataSecurity__CommomCSSWrapper">
        <div className="malware_overview">
          <Grid container direction="row" spacing={1.7}>
            <Grid item xs={3}>
              <Grid item style={{ height: '100%', display: 'flex', flexDirection: 'column', gap: '15px' }}>
                <AlertComponentsSkeleton />
                <AttackPathSkeleton />
              </Grid>
            </Grid>
            <Grid item xs={3.5}>
              <AssetOverviewSkeleton />
            </Grid>
            <Grid item xs={5.5}>
              <LiveSecretsSkeleton />
            </Grid>
          </Grid>
          <Grid container spacing={1.7}>
            <Grid item xs={6}>
              <SensitiveDataSkeleton />
            </Grid>
            <Grid item xs={6}>
              <ActiveThreatSkeleton />
            </Grid>
          </Grid>
          <Grid container spacing={1.7}>
            <Grid item xs={6}>
              <EntityFindingsSkeleton />
            </Grid>
            <Grid item xs={6}>
              <TopActiveActorSkeleton />
            </Grid>
          </Grid>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '15px', width: '100%' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Skeleton variant="rounded" width={300} height={36} />
              <Box sx={{ display: 'flex', gap: '10px' }}>
                <Skeleton variant="rounded" width={36} height={36} />
                <Skeleton variant="rounded" width={36} height={36} />
              </Box>
            </Box>
            <Skeleton variant="rectangular" width="100%" height={450} />
          </Box>
        </div>
      </div>
    </PageContent>
  );
}

export default DataSecuritySkeleton;
